/**
 * 竞赛天梯路由
 */
const routerCompetition = [
  {
    path: '/competition',
    name: 'Competition',
    meta: {
      title: '竞赛天梯',
      needLogin: false,
      transitionName: 'router',
      isTopMenu: true,
    },
    component: () => import('@/pages/module-competition/CompetitionList.vue'),
  },
  {
    path: '/competition/detail/:id',
    name: 'CompetitionDetail',
    meta: {
      title: '竞赛详情',
      needLogin: false,
      transitionName: 'router',
    },
    component: () => import('@/pages/module-competition/CompetitionDetail.vue'),
  },
  {
    path: '/competition/admission-ticket',
    name: 'AdmissionTicket',
    meta: {
      title: '准考证',
      needLogin: false,
      transitionName: 'router',
    },
    component: () => import('@/pages/module-competition/AdmissionTicket.vue'),
  },
];

export default routerCompetition;
